export * from "-!../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Recover.vue?vue&type=template&id=9888159a&"


//////////////////
// WEBPACK FOOTER
// ./src/components/login/Recover.vue?vue&type=template&id=9888159a&
// module id = 947
// module chunks = 0